import { baseApi } from "./baseApi";

const BRANCH_TALLY_BASE_URL = "/branch-tally";

export const branchTallyApi = baseApi.injectEndpoints({
  tagTypes: ["BranchTally"],
  endpoints: (builder) => ({
    createBranchTally: builder.mutation({
      query: (payload) => ({
        url: BRANCH_TALLY_BASE_URL,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [{ type: "BranchTally", id: "LIST" }],
    }),
    getBranchTallyList: builder.query({
      query: (params) => ({ url: BRANCH_TALLY_BASE_URL, params }),
      providesTags: (result) =>
        result && Array.isArray(result.data)
          ? [
              ...result.data.map(({ _id }) => ({
                type: "BranchTally",
                id: _id,
              })),
              { type: "BranchTally", id: "LIST" },
            ]
          : [{ type: "BranchTally", id: "LIST" }],
    }),
    getBranchTallyDetail: builder.query({
      query: (id) => `${BRANCH_TALLY_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "BranchTally", id },
        { type: "BranchTally", id: "LIST" },
      ],
    }),
    scanShipment: builder.mutation({
      query: (payload) => ({
        url: `${BRANCH_TALLY_BASE_URL}/scan`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (result, error, { tallyId }) => [
        { type: "BranchTally", id: tallyId },
      ],
    }),
    getBranchTallyReport: builder.query({
      query: (id) => `${BRANCH_TALLY_BASE_URL}/report/${id}`,
      providesTags: (result, error, id) => [{ type: "BranchTally", id }],
    }),
    completeUserTally: builder.mutation({
      query: (id) => ({
        url: `${BRANCH_TALLY_BASE_URL}/${id}/complete-user`,
        method: "PUT",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "BranchTally", id },
        { type: "BranchTally", id: "LIST" },
      ],
    }),
    completeBranchTally: builder.mutation({
      query: (id) => ({
        url: `${BRANCH_TALLY_BASE_URL}/complete/${id}`,
        method: "PUT",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "BranchTally", id },
        { type: "BranchTally", id: "LIST" },
      ],
    }),
    verifyBranchTally: builder.mutation({
      query: (id) => ({
        url: `${BRANCH_TALLY_BASE_URL}/${id}/verify`,
        method: "PUT",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "BranchTally", id },
        { type: "BranchTally", id: "LIST" },
      ],
    }),
    holdBranchTally: builder.mutation({
      query: (id) => ({
        url: `${BRANCH_TALLY_BASE_URL}/${id}/hold`,
        method: "PUT",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "BranchTally", id },
        { type: "BranchTally", id: "LIST" },
      ],
    }),
    resumeBranchTally: builder.mutation({
      query: (id) => ({
        url: `${BRANCH_TALLY_BASE_URL}/${id}/resume`,
        method: "PUT",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "BranchTally", id },
        { type: "BranchTally", id: "LIST" },
      ],
    }),
    addParticipants: builder.mutation({
      query: ({ id, participants }) => ({
        url: `${BRANCH_TALLY_BASE_URL}/${id}/participants`,
        method: "PUT",
        body: { participants },
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "BranchTally", id },
        { type: "BranchTally", id: "LIST" },
      ],
    }),
    checkInProgressBranchTally: builder.query({
      query: (params) => ({ url: `${BRANCH_TALLY_BASE_URL}/check`, params }),
      providesTags: (result, error, params) => [
        { type: "BranchTally", id: params.branch },
      ],
    }),
  }),
});

export const {
  useCreateBranchTallyMutation,
  useGetBranchTallyListQuery,
  useLazyGetBranchTallyListQuery,
  useGetBranchTallyDetailQuery,
  useScanShipmentMutation,
  useAddParticipantsMutation,
  useGetBranchTallyReportQuery,
  useCompleteUserTallyMutation,
  useCompleteBranchTallyMutation,
  useVerifyBranchTallyMutation,
  useHoldBranchTallyMutation,
  useResumeBranchTallyMutation,
  useCheckInProgressBranchTallyQuery,
  useLazyCheckInProgressBranchTallyQuery,
} = branchTallyApi;
